import { Inject, Injectable, OnInit, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Product } from '@app/model/product';
import { isPlatformBrowser } from '@angular/common';
import { environment } from './../../../environments/environment.prod';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService implements OnInit {
  subscribe(arg0: (status: any) => void) {
    throw new Error('Method not implemented.');
  }
  API_BASE_PATH = environment.API_URL;
  selectedProductForCheckout!: Product;
  cartItem:any;
  items:any;
  
  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: object) { }
 
  
  ngOnInit() {
    this.cartItem = localStorage.getItem('cart');
  }

  
  getSelectedProductForCheckout() {
    return this.selectedProductForCheckout;
  }

  setSelectedProductForCheckout(product: Product) {
    this.selectedProductForCheckout = product;
  }

  // Phone Pay
  payWithphonePay(data: any) {
    return this.http.post(`${this.API_BASE_PATH}phonePay`, data);
  }
 
  // Razor Pay
  createOrder(product: Product) {
    const payload = {
      productName: product.sellProductTitle,
      amount: product.sellProductPrice,
    };
    return this.http.post(`${this.API_BASE_PATH}createPaymentOrder`, {payload}, {headers: { 'Content-Type': 'application/json' }});
  }

  // Razor Pay
  verifyPaymentSignature(checkoutResponse: any, original_order_id: string) {
    const payload = {
      razorpay_signature: checkoutResponse.razorpay_signature,
      original_order_id: original_order_id,
      razorpay_payment_id: checkoutResponse.razorpay_payment_id,
    };
debugger
    return this.http.post(`${this.API_BASE_PATH}validatePayment`, payload);
  }

  getRazorPayKey() {
    return this.http.get(environment.RAZORPAY_KEY_ID);
  }

  get nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    }
  }

  subject = new Subject<any>();
  addToCart(product: Product) {
    debugger
    let local_storage;
    let itemsInCart = []
    this.items = {
      product: product,
      quantity: 1,
    }
    if(localStorage.getItem('cart')  == null){
      local_storage =[];
      //console.log("LOCALSTORAGE NULL",JSON.parse(this.cartItem));
      itemsInCart.push(this.items);
      localStorage.setItem('cart', JSON.stringify(itemsInCart));
      this.subject.next('changed');
      console.log('Pushed first Item: ', itemsInCart);
    }
    else
    {
      this.cartItem = localStorage.getItem('cart');
      local_storage = JSON.parse(this.cartItem);
      
      console.log("LOCAL STORAGE HAS ITEMS",JSON.parse(this.cartItem));
      for(var i in local_storage)
      {
        //console.log(local_storage[i].product.sellProductInfoId);
        if(this.items.product.sellProductInfoId == local_storage[i].product.sellProductInfoId)
        {
          local_storage[i].quantity += 1;
          console.log("Quantity for "+i+" : "+ local_storage[i].quantity);
          console.log('same product! index is ', i); 
          this.items=null;
          break;  
        }
    }
    if(this.items){
      itemsInCart.push(this.items);
    }
    local_storage.forEach(function (item:any){
      itemsInCart.push(item);
    })
    localStorage.setItem('cart', JSON.stringify(itemsInCart));
    }
  }
  
  getItems(){
   //console.log("Cart: ", localStorage.getItem('cart'));
   this.items = localStorage.getItem('cart');
   return JSON.parse(this.items);
   //return this.items;
   debugger
  }

  deleteItem(item:any){
    item = item;
    console.log("Deleting : ",item);
    let shopping_cart;
    let index;
    shopping_cart = JSON.parse(this.cartItem);
    for(let i in shopping_cart){
      if (item.product.sellProductTitle == shopping_cart[i].product.sellProductTitle)
      {
        index = i;
        console.log(index);
      }
    }
    shopping_cart.splice(index, 1);
    console.log("shopping_cart ", shopping_cart);
    localStorage.setItem('cart', JSON.stringify(shopping_cart));

  }

  addQty(item: any)
  {
    item = item;
    let shopping_cart;
    shopping_cart = JSON.parse(this.cartItem);
    for(let i in shopping_cart){
      if(item.product.sellProductTitle == shopping_cart[i].product.sellProductTitle){
        shopping_cart[i].quantity +=1;
        item = null;
        break;
      }
    }
    localStorage.setItem('cart', JSON.stringify(shopping_cart));
  }

  numberOfItems(){
    let itemsInCart = JSON.parse(this.cartItem);
    return itemsInCart.length;
  }
  
  clearCart(){
    this.cartItem.clear();
  }
}

function _window(): any {
  // return the global native browser window object
  return window;
}